import { createMemo } from 'solid-js';
import { breadcrumbEngine } from './engine';
import type { BreadcrumbContext } from './types';

export function useFunctionalBreadcrumbs(contextAccessor: () => BreadcrumbContext) {
  const breadcrumbResult = createMemo(() => {
    const context = contextAccessor();
    return breadcrumbEngine.generate(context);
  });

  const breadcrumbItems = createMemo(() => breadcrumbResult().breadcrumbs);
  const backLink = createMemo(() => breadcrumbResult().backLink);

  return {
    breadcrumbItems,
    backLink,
  };
}
